/* 
 * @author Tommy Brière
 * @copyright (c) 2016 Groupe PVP
 * @fileoverview TODO
 */
/* global Promise */

(function($g) {
   "use strict"; 
   var MIN_SCHEDULE_WAIT = 1000;

    function HommageData(server, data, url, lateDataUrl) {
        var me = this;
        var isReady = false;        
        var updateInterval;
        var nbLock = 0;
        var timeout;
        var targetTime;
        
        me.data = data;
        
        function time() {
            return new Date().getTime();
        }
        
        function scheduleTimeout() {
            if (nbLock===0) {
                var now = time();
                var delta = Math.max(MIN_SCHEDULE_WAIT, targetTime-now);
                clearTimeout(timeout);
                timeout = setTimeout(update, delta);
            }
        }
        
        function update() {
            if (nbLock>0) {
                $g.log("skipping update, lock in place...");
                return;
            }
            if (!server.isReady()) {//Ne rien faire si communication en cours
                scheduleTimeout();
                return;
            }
            server.call(url, {}, function (r) {
                var now = time();
                targetTime = now + updateInterval;
                if (nbLock>0) {
                    $g.log("skipping update, lock in place...");
                    return;
                }               
                isReady=true;
                if (lateDataUrl && lateDataUrl !="") {
                    url=lateDataUrl;
                }
                
                me.lock();
                data.set(r);
                me.unlock();
            }, function(e) {
                //donc care for errors!
                var now = time();
                targetTime = now + updateInterval;
                $g.warning("Failed polling server " + url, e);
                scheduleTimeout();
            });            
        }

        /**
         * Force update now
         * @param {type} ignoreLocks
         * @returns {undefined}
         */
        me.updateNow = function(ignoreLocks){
            if (nbLock>0 && !ignoreLocks) {
                $g.log("skipping update, lock in place...");
                return;
            }

            server.call(url, {}, function (r) {
                var now = time();
                targetTime = now + updateInterval;
                if (nbLock>0 && !ignoreLocks) {
                    $g.log("skipping update, lock in place...");
                    return;
                }
                isReady=true;
                me.lock();
                data.set(r);
                me.unlock();
            }, function(e) {
                //donc care for errors!
                var now = time();
                targetTime = now + updateInterval;
                $g.warning("Failed polling server " + url, e);
                scheduleTimeout();
            });
        };
        
        me.start = function(interval) {
            updateInterval = interval;
            //updateInterval = 3000;
            update();
        };
        
        me.stop = function() {
            nbLock = 9;
            clearTimeout(timeout);
            data = null;
        };
        
        /**
         * Attendre d'avoir les données initiales
         * @param {function} f
         * @returns {Promise|Promise.resolve}
         */
        me.ready = function(f) {
            f=f||function(){};
            if (isReady) {
                f(data);
                return Promise.resolve(data);
            } else {
                return new Promise(function(accept) {
                    data.afterChange.once(function() {
                        accept(data);
                        f(data);
                    });
                });
            }
        };
        
        /**
         * Verroiller le système pendant une opération
         * Qui doit être exécuter en exclusivité
         * Le verrou est placé immédiatement
         * @param {function} f
         * @returns {undefined}
         */
        me.lock = function(f) {//TODO: Ne plus utilisé "f", ce n'est plus nécessaire
            clearTimeout(timeout);
            nbLock++;
            $g.assert(nbLock <= 2, "plus de 2 lock... vérifié que les lock sont balancées");
            if (f) {
                server.ready(f);//Attendre la fin des opérations serveurs en cours...
            }
        };
        
        /**
         * Attendre que le système soit prèt avant de verrouiller
         * @returns {undefined}
         */
        /*me.waitForLock = function(f) {
            me.ready(function() {
                me.lock(f);
            });
        };*/
        
        me.unlock = function() {
            server.ready(function() {
                nbLock--;
                if (nbLock === 0) {
                    scheduleTimeout();
                } else {
                    $g.assert(nbLock >= 0, "lock cannot be < 0");
                }                
            });
        };
        
        me.isUnlocked = function() {
            return (nbLock===0);
        };
    }

    $g.HommageData = HommageData;
})(_P);